document.addEventListener("DOMContentLoaded", function () {

  console.log("Sticky Cart Loaded");

  const stickyBtn = document.getElementById("sticky-atc-btn");

  if (!stickyBtn) return;

  stickyBtn.addEventListener("click", function () {

    // Sticky Quantity
    const stickyQty = document.getElementById("sticky-qty");

    // Original Quantity Input
    const mainQty = document.querySelector('input[name="quantity"]');

    if (stickyQty && mainQty) {
      mainQty.value = stickyQty.value;
      mainQty.dispatchEvent(new Event("change", { bubbles: true }));
    }

    // Original Add to Cart Button
    const originalBtn = document.querySelector(
      'product-form button[type="submit"]'
    );

    if (originalBtn) {
      originalBtn.click();
    }

  });

});